<nz-checkbox-group class="checkbox-group-vertical" [(ngModel)]="_options" (ngModelChange)="onCheckBoxesModelChange($event)">
</nz-checkbox-group>
<label nz-checkbox [nzChecked]="!!customText">
  <input type="text" nz-input [(ngModel)]="customText" (ngModelChange)="onCustomInputChange($event)" [placeholder]="'assessment.answer-other.placeholder' | translate" (click)="stopPropagation($event)"/>
</label>
